export default function NotAuthorizedPage(): JSX.Element {
  return <div>권한없음</div>
}
